// src/components/markdown-renderer/hooks/useSectionHandlers.ts
import { useState } from 'react'

export const useSectionHandlers = (
    onSectionSelect?: (sectionId: string, sectionName: string, event: React.MouseEvent) => void
) => {
    const [selectedSection, setSelectedSection] = useState<string | null>(null)

    const handleSectionClick = (sectionId: string, sectionName: string, event: React.MouseEvent) => {
        // We need to keep this event exactly as it is for the context menu positioning
        event.stopPropagation()
        // Only ignore the click if it's on interactive elements
        if (
            event.target instanceof HTMLElement &&
            (event.target.closest('.section-review-panel') ||
                event.target.closest('button'))
        ) {
            // If clicking on controls within the section, don't select the section
            return
        }

        // Important: DO NOT stop propagation - the flow needs the original event
        // to correctly position the context menu

        setSelectedSection(sectionId)
        if (onSectionSelect) {
            // Pass section name along with ID and event
            onSectionSelect(sectionId, sectionName, event)
        }
    }

    const formatDate = (timestamp?: number) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return {
        selectedSection,
        setSelectedSection,
        handleSectionClick,
        formatDate
    }
}
